<template>
  <d-container
    fluid
    class="main-content-container p-0 mt-3">
    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0" style="width: 80px;">{{ $t('image.photo') }}</th>
            <th scope="col" class="border-0">{{ $t('ui.name') }}</th>
            <th scope="col" class="border-0" style="min-width: 200px;">{{ $t('product.productCode') }}</th>
            <th scope="col" class="border-0" style="min-width: 120px;">{{ $t('product.piecesInBox') }}</th>
            <th scope="col" class="border-0 text-center" style="min-width: 120px;">{{ $t('price.priceImportFrom') }}</th>
            <th scope="col" class="border-0 text-center" style="min-width: 120px;">{{ $t('price.price') }}</th>
            <th scope="col" class="border-0">{{ $t('product.availableQuantity') }}</th>
            <th scope="col" class="border-0">{{ $t('ui.actions') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(product, index) of products"
            :key="'product-' + index">
            <td class="align-middle">
              <img
                v-if="product.image_url"
                :src="product.image_url"
                alt=""
                class="product-image" />
              <span
                v-else
                class="product-empty-image">
                <i class="material-icons">camera_alt</i>
              </span>
            </td>
            <td class="align-middle">
              {{ product.name }}
              <br v-if="product.available_in_purchase">
              <d-badge
                v-if="product.available_in_purchase"
                theme="success">
                {{ $t('product.availableInPurchases') }}
              </d-badge>
              <d-badge
                v-if="product.is_sale"
                theme="warning"
                class="ml-1">
                {{ $t('product.isSale') }}
              </d-badge>
              <br>
              <small>{{ $t('ui.created') }}: {{ product.created_at }}</small><br>
              <small
                v-if="product.default_services && product.default_services.length"
                class="text-primary">
                {{ $t('product.productIncludesDefaultServices') }}: {{ product.default_services.length }}
              </small>
              <br v-if="product.default_services && product.default_services.length">
              <small>{{ $t('product.minimalQty') }}: {{ product.minimum_quantity }} {{ $t('ui.piecesAbbr') }}</small>
            </td>
            <td class="align-middle">
              {{ product.code }}<br>
              <small>{{ $t('product.eanGtinCode') }}:</small><br>
              <small v-if="product.ean">
                {{ product.ean }}
              </small>
              <small v-else>
                {{ $t('ui.lack') }}
              </small>
            </td>
            <td class="align-middle">
              {{ product.pieces_in_carton }} {{ $t('ui.piecesAbbr') }}<br>
              <small>({{ $t('product.actually') }}: {{ product.real_pieces_in_carton }} {{ $t('ui.piecesAbbr') }})</small>
            </td>
            <template v-if="isIndentList">
              <td class="align-middle">
                {{ $t('product.productIndentBaseProduct') }}: <strong>{{ product.base_product_name }}</strong><br>
                {{ $t('product.indentProduct.weight') }}: <strong>{{ product.weight }} kg</strong><br>
                {{ $t('product.indentProduct.cnCode') }}: <strong>{{ product.cn_code }}</strong><br>
                {{ $t('product.indentProduct.originCountry') }}: <strong>{{ product.origin_country }}</strong>
              </td>
            </template>
            <td class="align-middle text-center">
              <small>
                <template v-if="product.import_price_method === 'PARENT'">
                  {{ $t('product.importPriceMethod.parent') }}<br>
                </template>
                <template v-if="product.import_price_method === 'OTHER_PRODUCT'">
                  {{ $t('product.importPriceMethod.other_product') }}<br>
                </template>
                <template v-if="product.import_price_method === 'OTHER_CHILD'">
                  {{ $t('product.importPriceMethod.other_child') }}<br>
                </template>
                <template v-if="product.import_price_method === 'CUSTOM'">
                  {{ $t('product.importPriceMethod.custom') }}<br>
                </template>
                {{ product.price_code }}
              </small>
            </td>

            <td class="align-middle text-center">
              <template v-for="(price, index) of product.prices">
                <span :key="'product-price-' + index + '-' + product.id" class="product-price">
                  {{ Number(price.price).toFixed(2) }}
                  <template v-if="price.currency">
                    {{ price.currency.code }}
                  </template>
                  <template v-else>
                    -
                  </template>
                </span>
              </template>
            </td>
            <td class="align-middle">
              {{ product.availability }}
            </td>
            <td class="align-middle" style="width: 190px;">
              <d-button
                theme="primary"
                @click.prevent="$router.push(editUrl + product.id)"
                class="mr-2"
                :title="$t('ui.edit')">
                <i class="material-icons">edit</i>
              </d-button>
              <d-button
                theme="danger"
                :disabled="removeInProgress"
                @click.prevent="removeProduct(product.id)"
                :title="$t('ui.delete')">
                <i class="material-icons">delete</i>
              </d-button>
            </td>
          </tr>
          <tr v-if="products.length === 0">
            <td
              colspan="8"
              class="text-center">
              {{ $t('product.noProductsToDisplay') }}&hellip;
            </td>
          </tr>
        </tbody>
      </table>
    </d-card>
  </d-container>
</template>

<script>
import ListUtils from './../../utils/ListUtils.js';

export default {
  name: 'product-variants',
  props: [
    'products',
    'currencies'
  ],
  computed: {
    isIndentList () {
      return this.$route.path.indexOf('/produkty-indent') > -1;
    },
    editUrl () {
      if (this.isIndentList) {
        return '/produkty-indent/edycja/';
      }

      return '/produkty/edycja/';
    }
  },
  data() {
    return {
      removeInProgress: false
    };
  },
  methods: {
    removeProduct (productID) {
      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/products/delete/',
        id: productID,
        successTitle: this.$t('product.removeVariantSuccessTitle'),
        successText: this.$t('product.removeVariantSuccessText'),
        confirmTitle: this.$t('product.removeVariantConfirmTitle'),
        confirmText: this.$t('ui.deleteConfirmText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('product.removeVariantErrorText'),
        successAction: () => {
          this.removeInProgress = false;
          this.$bus.$emit('product-edit-variants-reload-needed');
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.product {
  &-image {
    height: auto;
    max-height: 80px;
    max-width: 80px;
    width: auto;
  }

  &-empty-image {
    align-items: center;
    background: #e5e5e5;
    color: #fff;
    display: flex;
    font-size: 48px;
    height: 80px;
    justify-content: center;
    width: 80px;
  }

  &-price {
    display: block;
    font-size: 12px;
  }
}
</style>
